$(function() {
  var swatchImages = $('.product-swatch-inline__image');
  if (swatchImages.length > 0) {
    swatchImages.hover(function() {
      var productId = $(this).data('id');
      var imageElement = $('.product-block__image[data-id="'+productId+'"]');
      var productBlock = $(this).closest('.product-block');
      var titleLink = productBlock.find('.product-block__title-link');
      titleLink.attr('href', imageElement.attr('href'));
      imageElement.siblings().hide();
      imageElement.show();
    });
  }
});